<div class="flex-row column align-center bg-color-FFF1CC">
    <ng-container *ngIf="!isLoading">
        <ng-container *ngIf="!isLoggedIn">
            <div class="flex-row column align-center row-gap-20 p-24 full">
                <img class="max-width-md-11 max-width-18" src="assets/new-assets/offer-reward.png" alt="Offer reward">
                <p class="text-dark fs-32 fw-9 lh-32">{{this.totalReward | currency:'INR':'symbol':'1.0-0'}} REWARD</p>
                <p class="text-center max-width-23 fw-6 lh-24">Congrats! You will receive a reward of {{this.totalReward
                    | currency:'INR':'symbol':'1.0-0'}} in your UPI</p>
                <ul class="flex-row column text-secondary align-center fs-md-14 row-gap-10">
                    <ng-container *ngFor="let item of data.availableRewards;">
                        <li>{{item.tittle}} - {{item?.amount |currency:'INR':'symbol':'1.0-0'}}</li>
                    </ng-container>
                </ul>
                <button type="button" class="btn btn-primary width-32 full-md" (click)="closeDialog()">Let's
                    Go!</button>
            </div>
        </ng-container>
        <ng-container *ngIf="isLoggedIn">
            <ng-container *ngIf="data.availableRewards.length">
                <ng-container *ngIf="currentReward">
                    <div
                        class="p-24 flex-row align-center column-gap-15 text-start fs-md-14  color-secondary bg-color-FFE399 full">
                        <tick-icon bgColor="#01AE45" borderColor="#01AE45" tickColor="white"
                            [widthHeight]="32"></tick-icon>
                        <p> We have added a reward of {{currentReward.amount | currency:'INR':'symbol':'1.0-0'}} for
                            <ng-container *ngIf="currentReward.activity === 'admin_offers_signup'">signing
                                up.</ng-container>
                            <ng-container *ngIf="currentReward.activity === 'admin_offers_riskProfiling'">risk profile
                                completion.</ng-container>
                            <!-- <ng-container *ngIf="currentReward.rewardConfiguration.activity === 'free_pack_subscription_rfd'">free investpack subscription.</ng-container> -->
                            <ng-container *ngIf="currentReward.activity === 'admin_offers_paid_subscription'">completing
                                a paid subscription.</ng-container>
                            <!-- <ng-container *ngIf="currentReward.rewardConfiguration.activity === 'first_time_investment_rfd'">first time investment.</ng-container> -->
                            Claim it in the rewards section.
                        </p>
                    </div>
                </ng-container>
                <div class="flex-row column align-center row-gap-25 p-24 full">
                    <img class="max-width-md-11 max-width-18" src="assets/new-assets/offer-reward.png" alt="Reward">
                    <p class="text-dark fs-32 fw-9 lh-32">GET {{this.totalReward | currency:'INR':'symbol':'1.0-0'}}
                        <span *ngIf="currentReward">MORE</span>
                    </p>
                    <p class="text-center max-width-23 text-dark fw-6">You can get a reward of {{totalReward |
                        currency:'INR':'symbol':'1.0-0'}}
                        <span *ngIf="currentReward"> more</span> in your UPI -
                    </p>
                    <ul class="flex-row column row-gap-8 mb-25 color-secondary">
                        <ng-container *ngFor="let item of data.availableRewards">
                            <li *ngIf="item.activity === 'admin_offers_riskProfiling'">Complete your Risk Profile -
                                {{item?.amount | currency:'INR':'symbol':'1.0-0'}}</li>
                            <!-- <li *ngIf="item.activity === 'free_pack_subscription_rfd'">Subscribe to a free Investpack - {{item?.amount | currency:'INR':'symbol'}}</li> -->
                            <li *ngIf="item.activity === 'admin_offers_paid_subscription'">Complete a Paid Subscription
                                - {{item?.amount | currency:'INR':'symbol':'1.0-0'}}</li>
                            <!-- <li *ngIf="item.activity === 'first_time_investment_rfd'">After your first Investment - {{item?.amount | currency:'INR':'symbol'}}</li> -->
                        </ng-container>
                    </ul>
                    <button type="button" class="btn btn-primary width-32 full-md" (click)="goTo('next')">Get
                        Started</button>
                </div>
            </ng-container>
            <ng-container *ngIf="currentReward && !data.availableRewards.length">
                <div class="flex-row column align-center row-gap-20 p-24 full">
                    <img class="max-width-md-11 max-width-18" src="assets/new-assets/offer-reward.png"
                        alt="Reward unlock">
                    <p class="text-center max-width-23 fs-18 fs-md-16 fw-8">You have unlocked a reward of
                        {{currentReward.amount | currency:'INR':'symbol':'1.0-0'}}</p>
                    <p class="fw-5 text-secondary">You will get the reward in your UPI id</p>
                    <input class="bg-white border-radius-8 pt-10 pb-10 pl-15 border-color-8ABECB width-32 full-md"
                        specialChar [formControl]="name" placeholder="Enter your name" aria-label="Enter your name"
                        *ngIf="!currentUser.name && !currentUser.isEditVpa">
                    <input class="bg-white border-radius-8 pt-10 pb-10 pl-15 border-color-8ABECB width-32 full-md"
                        [formControl]="vpa" placeholder="Enter your UPI id" aria-label="Enter your upi id">
                    <button type="button" class="btn btn-primary width-32 full-md"
                        [disabled]="name.invalid || vpa.invalid" (click)="claimReward(currentReward?._id)">Claim
                        Reward</button>
                    <button type="button" class="btn btn-outline border-none p-0 bg-none" (click)="closeDialog()">Maybe
                        Later</button>
                </div>
            </ng-container>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="isLoading">
        <app-loader></app-loader>
    </ng-container>
</div>